module.exports = __webpack_public_path__ + "img/jifenshangcheng.396b90cf.png";